import React from "react";
import { Button, Col, Image, Row } from "react-bootstrap";

import AashrayLogo from "../images/aashray.jpg";
import EminenceLogo from "../images/Eminence.jpg";
import GurukulLogo from "../images/Gurukul.jpg";
import JSGIFLogo from "../images/logo.png";
import SRCLogo from "../images/JSGIFSRCLogo 1.jpg";
import PariLogo from "../images/Pari.jpg";
import UdaanLogo from "../images/Udaan.jpg";

import Aashray from "../images/Aashray.zip";
import Eminence from "../images/Eminence.zip";
import Gurukul from "../images/Gurukul.zip";
import JSGIF from "../images/JSGIF.zip";
import SRC from "../images/JSGIFSRCLogo.zip";
import Pari from "../images/Pari.zip";
import Udaan from "../images/Udaan.zip";

import "./LogoDownloads.css";
import { saveAs } from "file-saver";

function LogoDownloads() {
  function downloader(file, filename) {
    saveAs(file, filename);
  }

  return (
    <div>
      <Row>
        <h1>Logo Downloads</h1>
      </Row>
      <Row>
        <h2 style={{ textAlign: "center" }}>Federation Logos</h2>
        <Col xs={12} md={6}>
          <div className="downloadCard">
            <Image src={JSGIFLogo} height="160px" />
            <h3>JSGIF</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(JSGIF, "JSGIF Logo")}
            >
              Download
            </Button>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className="downloadCard">
            <Image src={SRCLogo} height="160px" />
            <h3>South Region</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(SRC, "JSGIF SRC Logos")}
            >
              Download
            </Button>
          </div>
        </Col>
      </Row>

      <Row style={{ marginTop: "30px" }}>
        <h2 style={{ textAlign: "center" }}>Venture Logos</h2>
        <Col xs={12} md={4} lg={3}>
          <div className="downloadCard">
            <div className="downloadImgContainer">
              <Image src={AashrayLogo} className="downloadImage" fluid />
            </div>
            <h3>Aashray</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(Aashray, "Aashray Logo")}
            >
              Download
            </Button>
          </div>
        </Col>

        <Col xs={12} md={4} lg={3}>
          <div className="downloadCard">
            <div className="downloadImgContainer">
              <Image src={EminenceLogo} className="downloadImage" fluid />
            </div>
            <h3>Eminence</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(Eminence, "Eminence Logo")}
            >
              Download
            </Button>
          </div>
        </Col>

        <Col xs={12} md={4} lg={3}>
          <div className="downloadCard">
            <div className="downloadImgContainer">
              <Image src={GurukulLogo} className="downloadImage" fluid />
            </div>
            <h3>Gurukul</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(Gurukul, "Gurukul Logo")}
            >
              Download
            </Button>
          </div>
        </Col>

        <Col xs={12} md={4} lg={3}>
          <div className="downloadCard">
            <div className="downloadImgContainer">
              <Image src={PariLogo} className="downloadImage" fluid />
            </div>
            <h3>Pari</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(Pari, "Pari Logo")}
            >
              Download
            </Button>
          </div>
        </Col>

        <Col xs={12} md={4} lg={3}>
          <div className="downloadCard">
            <div className="downloadImgContainer">
              <Image src={UdaanLogo} className="downloadImage" fluid />
            </div>
            <h3>Udaan</h3>
            <Button
              className="btn--secondary"
              style={{ width: "100%", marginTop: "10px" }}
              onClick={() => downloader(Udaan, "Udaan Logo")}
            >
              Download
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default LogoDownloads;
